import React from 'react';
import SEO from '../components/seo';
import Layout from '../components/layout';
import Header from '../components/header/header';
import Hero from '../components/pricing-page/hero';
import PricingPlansDesktop from '../components/pricing-page/pricing-plans-desktop';
import PricingPlansMobile from '../components/pricing-page/pricing-plans-mobile';
import StickyNav from '../components/sticky-nav';

const PricingPage = () => (
  <Layout>
    <SEO title='Pricing Plans' />
    <Header />
    <Hero />
    <PricingPlansDesktop />
    <PricingPlansMobile />
    <StickyNav />
  </Layout>
);

export default PricingPage;
